import React from "react";
import { List, ListItem, ListItemText, makeStyles, Typography, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  list: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  listItem: {
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  listItemActive: {
    cursor: "pointer",
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    padding: theme.spacing(3, 2),
    fontWeight: 700,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }
}));

export default function ComponentsList({ components, activeComponent, onSelectComponent }) {
  const classes = useStyles();

  return (
    <Paper className={classes.mainContainer} elevation={0} square>
      <Typography variant="h6" className={classes.title}>
        Guia de Componentes
      </Typography>
      <List className={classes.list} disablePadding>
        {components.map((comp) => (
          <ListItem 
            key={comp.id} 
            onClick={() => onSelectComponent(comp)}
            className={activeComponent?.id === comp.id ? classes.listItemActive : classes.listItem}
          >
            <ListItemText 
              primary={<Typography variant="subtitle2" style={{ fontWeight: 600 }}>{comp.title}</Typography>} 
              secondary={<Typography variant="body2" color="textSecondary">{comp.description}</Typography>} 
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}